import {
  ControllerRenderProps,
  FieldPath,
  FieldValues,
  MultiSelect,
} from '@otp/ui';
import { useMemo } from 'react';
import { useDeviceContext } from 'src/context/device.context';
import { useCertificates } from 'src/hooks/query/lms/certificates/use-certificates';

type CertificatesProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  field: ControllerRenderProps<TFieldValues, TName>;
  programId?: string;
};

export const CertificatesField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  disabled = false,
  className,
  placeholder,
  field,
  programId,
}: CertificatesProps<TFieldValues, TName>) => {
  const { certificates, loading } = useCertificates({
    filter: { programIds: programId ? [programId] : undefined },
    skip: !programId,
  });

  const { isMobile } = useDeviceContext();
  const entityOptions = useMemo(
    () =>
      (certificates || []).map((entity) => ({
        value: entity.id as string,
        name: entity.name as string,
      })),
    [certificates, programId],
  );

  const defaultValue = field.value;

  return (
    <MultiSelect
      key={field.name}
      multiple={true}
      fullWidth={true}
      className={className}
      placeholder={placeholder}
      options={entityOptions || []}
      disabled={loading || disabled}
      {...field}
      defaultValue={defaultValue}
      value={field.value || []}
      ref={undefined}
      allowSelectAll={true}
      useCheckboxOption={true}
      limitTags={isMobile ? 2 : 2}
    />
  );
};
